import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_4 = { class: "pf-search" }
const _hoisted_5 = { class: "full-table" }
const _hoisted_6 = { class: "table-labels" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "no-emp-badge",
  title: "Not linked to a Team Hub employee. Link them from the employee's page (Sign-in accounts)."
}
const _hoisted_9 = {
  key: 1,
  class: "user-emp-sub"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { style: {"text-align":"center"} }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { style: {"text-align":"center"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_18 = { class: "form-wrapper slide-up" }
const _hoisted_19 = { class: "form-close" }
const _hoisted_20 = {
  key: 0,
  class: "user-emp-picked"
}
const _hoisted_21 = { class: "user-emp-list" }
const _hoisted_22 = {
  key: 0,
  class: "user-emp-taken"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "user-emp-sub"
}
const _hoisted_25 = { class: "checkbox-input" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { style: {"margin-bottom":"20px","max-height":"120px","overflow":"auto"} }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = {
  key: 3,
  class: "checkbox-input"
}
const _hoisted_30 = {
  key: 1,
  class: "error-msg-wrap"
}
const _hoisted_31 = { class: "form-wrapper slide-up" }
const _hoisted_32 = { class: "form-close" }
const _hoisted_33 = {
  key: 0,
  class: "user-emp-picked"
}
const _hoisted_34 = { class: "user-emp-list" }
const _hoisted_35 = {
  key: 0,
  class: "user-emp-taken"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "user-emp-sub"
}
const _hoisted_38 = { class: "checkbox-input" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { style: {"margin-bottom":"20px","max-height":"120px","overflow":"auto"} }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = {
  key: 3,
  class: "checkbox-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[31] || (_cache[31] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Admin Users")
      ], -1)),
      _createElementVNode("div", {
        class: "btn-light",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showGuide = true))
      }, "Permissions Guide")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.role == 'Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[32] || (_cache[32] = _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                "aria-hidden": "true"
              }, [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "7"
                }),
                _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQ) = $event)),
                placeholder: "Search",
                "aria-label": "Search",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search()))
              }, null, 544), [
                [_vModelText, _ctx.searchQ]
              ])
            ]),
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAddUserFn())),
              class: "add-btn"
            }, "Add")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_6, [
            _cache[34] || (_cache[34] = _createElementVNode("td", null, "Name", -1)),
            _cache[35] || (_cache[35] = _createElementVNode("td", null, "Email", -1)),
            _cache[36] || (_cache[36] = _createElementVNode("td", null, "Role", -1)),
            _cache[37] || (_cache[37] = _createElementVNode("td", null, null, -1)),
            (_ctx.$store.state.user.superAdmin)
              ? (_openBlock(), _createElementBlock("td", _hoisted_7))
              : _createCommentVNode("", true),
            _cache[38] || (_cache[38] = _createElementVNode("td", null, null, -1))
          ]),
          _cache[39] || (_cache[39] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(user.FirstName) + " " + _toDisplayString(user.LastName), 1),
                (!user.EmployeeID)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "No employee"))
                  : _createCommentVNode("", true),
                (user.EmployeeName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Employee: " + _toDisplayString(user.EmployeeName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: 'mailto:'+user.Email,
                  target: "_blank"
                }, _toDisplayString(user.Email), 9, _hoisted_10)
              ]),
              _createElementVNode("td", null, _toDisplayString(user.Role), 1),
              _createElementVNode("td", _hoisted_11, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (_ctx.showEditUserFn(user)), ["prevent"])
                }, "Edit", 8, _hoisted_12)
              ]),
              (_ctx.$store.state.user.superAdmin)
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.signInAsUser(user)), ["prevent"])
                    }, "Sign In As", 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (_ctx.deleteUser(user)), ["prevent"])
                }, "Delete", 8, _hoisted_16)
              ])
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showAddUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[4] || (_cache[4] = () => { _ctx.showAddUser = false })
              }, "×")
            ]),
            _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Employee", -1)),
            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "user-emp-hint" }, "Their Team Hub employee record. If that employee also has a standard user, they can switch between Admin and Standard.", -1)),
            (_ctx.addUserData.employeeID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_ctx.employeeName(_ctx.addUserData.employeeID)) + " ", 1),
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => { _ctx.addUserData.employeeID = null }, ["prevent"]))
                  }, "Remove")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Search employees",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.employeeSearchQ) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employeeSearchQ]
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeOptions(_ctx.addUserData.userID), (emp) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: emp.ID
                      }, [
                        (emp.linkedTo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(emp.Name) + " · linked to " + _toDisplayString(emp.linkedTo), 1))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: _withModifiers(() => { _ctx.addUserData.employeeID = emp.ID }, ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(emp.Name), 1),
                              (emp.SeatTitle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, " · " + _toDisplayString(emp.SeatTitle), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_23))
                      ]))
                    }), 128))
                  ]),
                  _cache[40] || (_cache[40] = _createElementVNode("div", { class: "user-emp-hint" }, "Leave empty to link the employee with their email, if there is one.", -1))
                ], 64)),
            _cache[48] || (_cache[48] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addUserData.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.addUserData.email]
            ]),
            _cache[49] || (_cache[49] = _createElementVNode("h3", null, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addUserData.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.addUserData.firstName]
            ]),
            _cache[50] || (_cache[50] = _createElementVNode("h3", null, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addUserData.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.addUserData.lastName]
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("h3", null, [
              _createTextVNode("Phone "),
              _createElementVNode("span", { class: "item-hint" }, "(optional, for text alerts)")
            ], -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.addUserData.phone,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addUserData.phone) = $event))
            }, null, 8, ["modelValue"]),
            _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Content Role", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.addUserData.role) = $event))
            }, [...(_cache[41] || (_cache[41] = [
              _createElementVNode("option", { value: "Editor" }, "Editor", -1),
              _createElementVNode("option", { value: "Reviewer" }, "Reviewer", -1),
              _createElementVNode("option", { value: "Admin" }, "Admin", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.addUserData.role]
            ]),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addUserData.restrictDepartments) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.addUserData.restrictDepartments]
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("h3", null, "Restrict Departments", -1))
            ]),
            (_ctx.addUserData.restrictDepartments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, "Select Departments the user will have access to", -1)),
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addUserData.departmentsNew, (department, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "checkbox-input"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((department.isChecked) = $event)
                        }, null, 8, _hoisted_28), [
                          [_vModelCheckbox, department.isChecked]
                        ]),
                        _createElementVNode("div", null, _toDisplayString(department.name), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[53] || (_cache[53] = _createElementVNode("h3", null, "Team Hub Role", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addUserData.teamHubRole) = $event))
            }, [...(_cache[44] || (_cache[44] = [
              _createElementVNode("option", { value: null }, "User", -1),
              _createElementVNode("option", { value: "Admin" }, "Admin", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.addUserData.teamHubRole]
            ]),
            (_ctx.$store.state.user.superAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addUserData.superAdmin) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.addUserData.superAdmin]
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("h3", null, "Super Admin", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitAddUser()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showEditUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[16] || (_cache[16] = () => { _ctx.showEditUser = false })
              }, "×")
            ]),
            _cache[59] || (_cache[59] = _createElementVNode("h3", null, "Employee", -1)),
            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "user-emp-hint" }, "Their Team Hub employee record. If that employee also has a standard user, they can switch between Admin and Standard.", -1)),
            (_ctx.editUserData.employeeID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_ctx.employeeName(_ctx.editUserData.employeeID)) + " ", 1),
                  _createElementVNode("a", {
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => { _ctx.editUserData.employeeID = null }, ["prevent"]))
                  }, "Remove")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Search employees",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.employeeSearchQ) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.employeeSearchQ]
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeOptions(_ctx.editUserData.userID), (emp) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: emp.ID
                      }, [
                        (emp.linkedTo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(emp.Name) + " · linked to " + _toDisplayString(emp.linkedTo), 1))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: _withModifiers(() => { _ctx.editUserData.employeeID = emp.ID }, ["prevent"])
                            }, [
                              _createTextVNode(_toDisplayString(emp.Name), 1),
                              (emp.SeatTitle)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " · " + _toDisplayString(emp.SeatTitle), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_36))
                      ]))
                    }), 128))
                  ])
                ], 64)),
            _cache[61] || (_cache[61] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editUserData.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.editUserData.email]
            ]),
            _cache[62] || (_cache[62] = _createElementVNode("h3", null, "First Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editUserData.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.editUserData.firstName]
            ]),
            _cache[63] || (_cache[63] = _createElementVNode("h3", null, "Last Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editUserData.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.editUserData.lastName]
            ]),
            _cache[64] || (_cache[64] = _createElementVNode("h3", null, [
              _createTextVNode("Phone "),
              _createElementVNode("span", { class: "item-hint" }, "(optional, for text alerts)")
            ], -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.editUserData.phone,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editUserData.phone) = $event))
            }, null, 8, ["modelValue"]),
            _cache[65] || (_cache[65] = _createElementVNode("h3", null, "Content Role", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editUserData.role) = $event))
            }, [...(_cache[54] || (_cache[54] = [
              _createElementVNode("option", { value: "Editor" }, "Editor", -1),
              _createElementVNode("option", { value: "Reviewer" }, "Reviewer", -1),
              _createElementVNode("option", { value: "Admin" }, "Admin", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.editUserData.role]
            ]),
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editUserData.restrictDepartments) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.editUserData.restrictDepartments]
              ]),
              _cache[55] || (_cache[55] = _createElementVNode("h3", null, "Restrict Departments", -1))
            ]),
            (_ctx.editUserData.restrictDepartments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _cache[56] || (_cache[56] = _createElementVNode("div", { style: {"margin-bottom":"20px"} }, "Select Departments the user will have access to", -1)),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editUserData.departmentsNew, (department, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "checkbox-input"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((department.isChecked) = $event)
                        }, null, 8, _hoisted_41), [
                          [_vModelCheckbox, department.isChecked]
                        ]),
                        _createElementVNode("div", null, _toDisplayString(department.name), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[66] || (_cache[66] = _createElementVNode("h3", null, "Team Hub Role", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editUserData.teamHubRole) = $event))
            }, [...(_cache[57] || (_cache[57] = [
              _createElementVNode("option", { value: null }, "User", -1),
              _createElementVNode("option", { value: "Admin" }, "Admin", -1)
            ]))], 512), [
              [_vModelSelect, _ctx.editUserData.teamHubRole]
            ]),
            (_ctx.$store.state.user.superAdmin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editUserData.superAdmin) = $event)),
                    style: _normalizeStyle(_ctx.editUserData.userID == _ctx.$store.state.user.userID ? 'pointer-events:none' : '')
                  }, null, 4), [
                    [_vModelCheckbox, _ctx.editUserData.superAdmin]
                  ]),
                  _cache[58] || (_cache[58] = _createElementVNode("h3", null, "Super Admin", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.submitEditUser()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 2,
          onConfirm: _cache[28] || (_cache[28] = ($event: any) => (_ctx.deleteUserConfirm())),
          onCancel: _cache[29] || (_cache[29] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this user?"
        }))
      : _createCommentVNode("", true),
    (_ctx.showGuide)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 3,
          url: "/ironbook-permissions-guide.pdf",
          onClose: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showGuide = false))
        }))
      : _createCommentVNode("", true)
  ]))
}